<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="系统公告">
        <a-button slot="extra" type="primary" @click="handleNewNotice">新建公告</a-button>
        <a-form layout="inline" @submit="handleSubmit" :form="form">
            <a-form-item label="标题">
                <a-input  allow-clear v-model="searchP.title" placeholder="请输入标题"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
            </a-form-item>
            <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
            </a-form-item>
        </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
         <span>
            <router-link
                    :to="{
                    path:'noticedetail',
                    query: {
                        id: record.id
                    }
                }"
                >查看</router-link>
          </span>
          <span>
            <router-link
                    :to="{
                    path:'noticeedit',
                    query: {
                        id: record.id
                    }
                }"
                >编辑</router-link>
          </span>
         <span>
            <a-popconfirm title="确认删除?" @confirm="() => onSysDelete(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
         
        </div>
      </template>

       <template slot="noticet" slot-scope="text">
          <a :href="'http://'+text" target="blank">{{text}}</a>
      </template>
    </a-table>

        <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />
 
 
  </div>
</template>
<script>

let searchP={
    notice:'',//域名
    total:0,
    pageSize:10,
    page:undefined,
};


const columns = [
    {
        title: "序号",
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
        width:80
    },
    {
        title: '标题',
        dataIndex: 'title',
        align: 'center',
        ellipsis: true,
        width:200,
        
    },
    {
        title: '描述',
        dataIndex: 'description',
        align: 'center',
        ellipsis: true,
        width:200,

    },
    {
        title: '链接',
        dataIndex: 'link',
        align: 'center',
        width:200,

    },
    {
        title: '创建时间',
        dataIndex: 'createtime',
        width:180,
        align: 'center',
    },
    {
        title: '更新时间',
        dataIndex: 'updatetime',
        width:180,
        align: 'center',
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
        width:150,

    }
];
const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            searchP,
            tLoading:true,
        };
    },
    methods: {
        getnoticeList(){
            let c_params = {
                ...searchP,
                urlparams:false
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "notice/querynoticelist",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        handlePageChange(c_p){
            this.searchP.page = c_p;
            this.updateRoute()
        },
        updateRoute(){
            this.$router.push({
                query: {
                    notice:this.searchP.title,
                    page:this.searchP.page
                }
            });
        },
        handleSearchReset(){
            this.searchP.page = 1;
            this.searchP.title='',//系统编码
            this.updateRoute() 
        },
        handleNewNotice(){
            this.$router.push({
                path: "noticeadd",
                query: {id:''}
            });
        },
        handleSubmit(e){
            e.preventDefault();
            this.searchP.page = 1;
            this.updateRoute()
        },
        onSysDelete(key) {
            this.$store.dispatch({
                type: "notice/deletenotice",
                params: {...key}
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getnoticeList();
                }
            });
        },

    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
    components:{
    },
    mounted(){
        const { query } = this.$route;
        this.searchP.title = query.title ? query.title : '';
        this.searchP.page = query.page ? +query.page : 1;
        this.getnoticeList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
